var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"Old Trans","icon":"mdi-delete","small":false,"xSmall":true,"loading":_vm.loading},on:{"click":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }